// Meta Pixel helper for pixel ID 797129573436368

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel(): void {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Add noscript pixel image
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=797129573436368&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', '797129573436368')
  window.fbq('track', 'PageView')
}

export function trackAddToCart(): void {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
